<template>
  <v-dialog v-model="config.status.active" max-width="600px">
    <v-card class="dialog">
      <v-card-title class="primary amber blue-grey--text text--darken-4">
        <span class="headline">プログラム名の変更</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="form.valid" lazy-validation>
            <v-row dense>
              <v-col cols="12">
                <v-text-field required counter
                  v-model="form.title"
                  label="プログラム/学校名"
                  maxlength="20"
                  :rules="rules.title"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="secondary" @click="close">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed color="secondary" @click="submit" :loading="isLoading">保存する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'authorProgsModalsTitle',
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false
        },
        datepickers: {
          date: false
        }
      },
      form: {
        valid: true,
        id: '',
        title: ''
      },
      rules: {
        title: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(this.$url.api + 'progs/update/item', {
            id: this.form.id,
            title: this.form.title
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$emit('done', res.data.data)
              this.close()
            }
            this.$set(this.config.status, 'loading', false)
          }).catch(err => {
            console.log(err)
            this.$set(this.config.status, 'loading', false)
          })
        })
      }
    },
    open: function (val) {
      console.log(val)
      const { id, title } = val
      this.$set(this.config.status, 'active', true)
      this.$set(this, 'form', {
        valid: true,
        id: id,
        title: title
      })
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    }
  },
  computed: {
    isActive () {
      return this.config.status.active
    },
    isLoading () {
      return this.config.status.loading
    }
  }
}
</script>
